module.exports = __webpack_public_path__ + "static/tab1-7f03975d546401a157934a4ac6c91798.png";